import URL from '../constants/URL';
import dataProxy from '../dataProxy';

export default {
  /**
   * 获取计价单位 信息
   * @returns {Promise<any>}
   */
  getValueUnit(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.ASSETS_VALUATION_UNIT, { params })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
};
